import { render, staticRenderFns } from "./shopCarts.vue?vue&type=template&id=44c3db24&scoped=true"
import script from "./shopCarts.vue?vue&type=script&lang=js"
export * from "./shopCarts.vue?vue&type=script&lang=js"
import style0 from "./shopCarts.vue?vue&type=style&index=0&id=44c3db24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c3db24",
  null
  
)

export default component.exports